import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { SquareButton } from "../components/common";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import noticeManager from "../apis/notice";
import { closeConfirm, openConfirm } from "../redux/ConfirmSlice";
import { useDispatch } from "react-redux";
import { getCookies } from "../utils";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const PolicyNotice = () => {
    const [fileName, setFileName] = useState("");
    const [row, setRow] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const admin = false;

    // 일정 기간동안만 유지
    const { data: list } = useQuery({
        queryKey: ["readNoticeDetail"],
        queryFn: async () => {
            const res = await noticeManager.getNoticeDetail(7);
            return res.data;
        },
        enabled: !location.state, // location.state 없을 때만 호출
    });

    useEffect(() => {
        if (list?.notice) {
            const notice = list.notice;
            setRow({
                id: notice.id,
                title: notice.title,
                contents: notice.contents,
                file_url: notice.file_url,
                writer: notice.writer,
                createdAt: notice.createdAt,
                updatedAt: notice.updatedAt,
                read_count: notice.read_count + 1,
            });
        }
    }, [list]);

    useEffect(() => {
        if (row?.file_url) {
            setFileName(row.file_url.replace("public/images/notice/", ""));
        }
        window.opener?.sessionStorage.setItem("notice-popup", "read");
    }, [row]);

    const handleDownloadClick = async () => {
        if (!row.file_url) {
            return dispatch(
                openConfirm({
                    confirmText: "확인",
                    text: "등록된 파일이 없습니다.",
                    isSingleButton: true,
                    confirmFunc: () => {
                        dispatch(closeConfirm());
                    },
                })
            );
        }

        const authToken = getCookies("ivBanner_auth");
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/notice/download?url=${row.file_url}`,
            {
                method: "GET",
                headers: {
                    'Authorization': `${authToken}`
                },
            }
        );

        if (!response.ok) {
            dispatch(
                openConfirm({
                    confirmText: "확인",
                    text: "파일 다운로드를 실패했습니다.",
                    isSingleButton: true,
                    confirmFunc: () => {
                        dispatch(closeConfirm());
                    },
                })
            );
        } else {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const fileName = row.file_url.replace("public/images/notice/", "");

            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    };

    return (
        <NoticePageContainer>
            <NoticeTitle>공지사항</NoticeTitle>
            <NoticeBodyContainer>
                <TableContainer>
                    <tbody>
                    <TableTitleArea>
                        <TableLeftTitle>글번호</TableLeftTitle>
                        <TableTitleData>{row?.id}</TableTitleData>
                        <TableTitle>날짜</TableTitle>
                        <TableTitleData>
                            {moment(row?.createdAt).format("YY.MM.DD")}
                        </TableTitleData>
                        <TableTitle>작성자</TableTitle>
                        <TableTitleData>이너뷰</TableTitleData>
                        <TableTitle>조회수</TableTitle>
                        <TableTitleData>{row?.read_count}</TableTitleData>
                    </TableTitleArea>
                    <TableTitleArea>
                        <TableLeftTitle>제목</TableLeftTitle>
                        <TableTitleData colSpan={5}>
                            {row?.title}
                        </TableTitleData>
                    </TableTitleArea>
                    <TableContentsArea>
                        <TableContents style={{ verticalAlign: "top" }}>
                            내용
                        </TableContents>
                        <TableContentsData colSpan={5}>
                            {row?.contents}
                        </TableContentsData>
                    </TableContentsArea>
                    {fileName &&
                        <TableFileArea>
                            <TableFile>첨부파일</TableFile>
                            <TableFileUpload colSpan={5}>
                                <FileUploader>
                                    <FileNameArea>{fileName}</FileNameArea>
                                    <SquareButton
                                        size="lg"
                                        onClick={handleDownloadClick}
                                    >
                                        파일 다운로드
                                    </SquareButton>
                                </FileUploader>
                            </TableFileUpload>
                        </TableFileArea>
                    }
                    </tbody>
                </TableContainer>
            </NoticeBodyContainer>
        </NoticePageContainer>
    );
};

const NoticePageContainer = styled.div`
    //padding: 72px 72px 0 72px;
    width: 100vw;
    height: 90vh;
    min-width: 1390px;
    overflow: auto;
    background-color: rgb(248, 249, 249);
`;

const NoticeTitle = styled.p`
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: #282B39;
`;

const NoticeBodyContainer = styled.div`
    width: 80%;
    margin-top: 30px;
    margin-bottom: 72px;
`;

const TableTitleArea = styled.tr`
    height: 50px;
    border-bottom: 1px solid #ccc;
`;

const TableLeftTitle = styled.td`
    padding: 20px 0 20px 40px;
    width: 130px;
    max-width: 130px;
    font-weight: bold;
    //border-right: 1px solid #000000;
    background-color: rgb(240, 240, 245);
`;

const TableContentsArea = styled.tr`
    height: 300px;
    border-bottom: 1px solid #ccc;
`;

const TableFileArea = styled.tr`
    height: 50px;
`;

const TableContainer = styled.table`
    width: 100%;
    height: 100%;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    //background-color: rgb(240, 240, 245);
`;

const TableTitle = styled.td`
    padding: 20px 0 20px 40px;
    width: 130px;
    max-height: 130px;
    font-weight: bold;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    background-color: rgb(240, 240, 245);
`;

const TableContents = styled.td`
    padding-top: 40px;
    width: 180px;
    max-height: 130px;
    padding-left: 40px;
    font-weight: bold;
    //border-right: 1px solid #000000;
    background-color: rgb(240, 240, 245);
`;

const TableFile = styled.td`
    padding: 20px 0 20px 40px;
    width: 180px;
    max-height: 130px;
    font-weight: bold;
    //border-right: 1px solid #000000;
    background-color: rgb(240, 240, 245);
`;

const TableTitleData = styled.td`
    padding: 20px 40px 20px 40px;
    width: 160px;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
`;

const TableContentsData = styled.td`
    padding: 20px 40px 20px 40px;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: pre-line;
    line-height: 1.25;
`;

const TableFileUpload = styled.td`
    padding: 20px 0 20px 40px;
    height: 80px;
    margin-bottom: 10px;
`;

const NoticeFooterContainer = styled.div`
    display: flex;
    width: 80%;
    justify-content: center;
    margin-bottom: 20px;
    gap: 10px;
`;

const CancelBtn = styled.button`
    transition: 0.2s ease-in-out;
    cursor: pointer;
    padding: 0px 56px;
    height: 48px;
    font-size: 16px;
    border: 1px solid var(--gray-black);
    background-color: #fff;
    border-radius: 50px;
    color: var(--gray-black);
    font-weight: 700;
`;

const FileUploader = styled.div`
    display: flex;
`;

const FileNameArea = styled.p`
    display: flex;
    justify-content: start;
    align-items: center;
    margin-right: 20px;
`;

const ModifyBtn = styled.button`
    transition: 0.2s ease-in-out;
    cursor: pointer;
    padding: 0px 56px;
    height: 48px;
    font-size: 16px;
    border: 1px solid var(--gray-black);
    background-color: var(--gray-black);
    border-radius: 50px;
    color: rgb(255, 255, 255);
    font-weight: 700;
`;

const DeleteWrap = styled.div`
    display: flex;
    position: relative;
    top: 15px;
    float: right;
`;

const DeleteBtn = styled.button`
    transition: 0.2s ease-in-out;
    cursor: pointer;
    height: 40px;
    font-size: 15px;
    border: 1px solid #7386E8;
    background-color: #7386E8;
    border-radius: 50px;
    color: rgb(255, 255, 255);
    width: 100px;
    font-weight: 600;
`;

export default PolicyNotice;
